function getIndegreesForNodes(nodes) {
    const indegrees = {};
    // eslint-disable-next-line @buildwithflux/no-array-foreach
    Object.values(nodes).forEach((node) => {
        if (indegrees[node.uid] === undefined) {
            indegrees[node.uid] = 0;
        }
        if (node.parentUid && Boolean(nodes[node.parentUid])) {
            indegrees[node.uid] = (indegrees[node.uid] ?? 0) + 1;
        }
    });
    return indegrees;
}
/**
 * Sort nodes in topological order and return a sorted array
 *
 * This is important when adding a list of nodes to our store because
 * usually we want to add them in topological order so that parent-child
 * relationship is correctly captured and built
 *
 * NOTE the worst case time complexity right now is O(n^2) but can be improved
 * to O(n), see comment below. It is fine to leave it with O(n^2) for now because
 * we never sort the whole nodes map, only sorting a subset of nodes when adding
 * parts or backfilling
 *
 * TODO: Improve time complexity
 *
 * @param nodes - a map of nodes to be sorted
 * @returns node array in topological order
 */
function sort(nodes) {
    const allNodes = Object.values(nodes);
    if (allNodes.length <= 1) {
        // No need to sort
        return allNodes;
    }
    const sorted = [];
    // O(n) time
    const indegrees = getIndegreesForNodes(nodes);
    // O(n) time
    const nodesWithNoIncomingEdges = allNodes.filter((node) => indegrees[node.uid] === 0);
    // Right now worst case here is O(n^2) time, and that is because we dont have
    // a node sibling map. This can be improved to O(n) if we built a node sibling
    // map, then we dont need to traverse allNodes again
    while (nodesWithNoIncomingEdges.length > 0) {
        const nodeWithNoIncomingEdges = nodesWithNoIncomingEdges.pop();
        if (nodeWithNoIncomingEdges) {
            sorted.push(nodeWithNoIncomingEdges);
            // eslint-disable-next-line @buildwithflux/no-array-foreach
            allNodes.forEach((node) => {
                if (node.parentUid === nodeWithNoIncomingEdges.uid) {
                    indegrees[node.uid] = (indegrees[node.uid] ?? 0) - 1;
                    if (indegrees[node.uid] === 0) {
                        nodesWithNoIncomingEdges.push(node);
                    }
                }
            });
        }
    }
    return sorted;
}
export function topologicalSort(nodes) {
    let nodesMap = {};
    if (Array.isArray(nodes)) {
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        nodes.forEach((node) => {
            nodesMap[node.uid] = node;
        });
    }
    else {
        nodesMap = nodes;
    }
    return sort(nodesMap);
}
//# sourceMappingURL=sort.js.map